import CardServices from "../CardServices";

const OurServices = ({ data }) => {

  return (
    <div className="col-10">
      <h1 className="text-white">Our Services</h1>
      <div className="row row-cols-4">
        {data.map((item, index) => {
          return <CardServices key={index} item={item} />;
        })}
      </div>
    </div>
  );
};

export default OurServices;
